module.exports = __webpack_public_path__ + "../assets/fonts/NeutraDisplay-Light.02f0a7b1dc47d0c1325470a343a0e8d6.otf";